<div class="code-container">
  <div class="header">
    <div class="title">
      {{ title }}
    </div>
    <div>
      <ng-container *ngIf="copyLabel; else iconButton">
        <button mat-stroked-button (click)="copyToClipboard()">
          <span>{{ copyLabel | translate }}</span>
          <mat-icon>{{ isCopying() ? 'done' : 'content_copy' }}</mat-icon>
        </button>
      </ng-container>
      <ng-template #iconButton>
        <button mat-icon-button (click)="copyToClipboard()">
          <mat-icon>{{ isCopying() ? 'done' : 'content_copy' }}</mat-icon>
        </button>
      </ng-template>
    </div>
  </div>
  <div>
    <pre><code #snippet><ng-content></ng-content></code></pre>
  </div>
</div>
